import React, { useState } from "react";
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from "react-native";
import { observer } from "mobx-react";
import { navigate } from "../services/NavigationService";
import { EnumRoutesAppWeb } from "../enum/EnumRoutesAppWeb";
import { PlusIcon, PencilSimpleIcon, TrashIcon, FunnelSimple as FilterIcon } from "@phosphor-icons/react";
import { Theme } from "../enum/Theme";
import { shoppingStore } from "../stores/ShoppingStore";
import { Language } from "@constants/language";
import { ModalFiltroLanguage } from "../comps/ModalFiltroLanguage";
import SpaceW from "@comps/SpaceW";
import { getFlagByLanguage } from "../services/getFlagByLanguage";

const Shopping = observer(() => {
  const { itens, loading, deleteItem } = shoppingStore;

  const [modalVisible, setModalVisible] = useState(false);
  const [filterLang, setFilterLang] = useState<Language | null>(null);

  const itensFiltered = filterLang
    ? itens.filter((i) => i.lang === filterLang)
    : itens;

  if (loading) {
    return <Text style={{ textAlign: "center", marginTop: 50 }}>Carregando...</Text>;
  }

  return (
    <View style={styles.container}>
      <View style={styles.topBar}>
        <TouchableOpacity style={styles.addButton} onPress={() => navigate(EnumRoutesAppWeb.createEditShopping)}>
          <PlusIcon size={20} color="#fff" />
          <Text style={styles.addButtonText}>Novo Item</Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.filterButton} onPress={() => setModalVisible(true)}>
          <FilterIcon size={22} color={Theme.foreground} />
        </TouchableOpacity>
      </View>

      <ScrollView>
        {itensFiltered.map((item) => (
          <View style={styles.row} key={item.id}>
            <View>
              <Text style={{ fontSize: 18 }}>{getFlagByLanguage(item.lang)}</Text>
            </View>
            <SpaceW />
            <Text numberOfLines={1} ellipsizeMode="tail" style={styles.rowText}>
              {item.title || "-"}
            </Text>
            <SpaceW />
            <View style={styles.actions}>
              <TouchableOpacity onPress={() => navigate(EnumRoutesAppWeb.createEditShopping, { item })}>
                <PencilSimpleIcon size={20} color="#555" />
              </TouchableOpacity>
              <SpaceW />
              <TouchableOpacity onPress={() => deleteItem(item.id)}>
                <TrashIcon size={20} color="#E57373" />
              </TouchableOpacity>
            </View>
          </View>
        ))}
      </ScrollView>

      <ModalFiltroLanguage
        visible={modalVisible}
        value={filterLang}
        onSelect={setFilterLang}
        onClose={() => setModalVisible(false)}
      />
    </View>
  );
});

export default Shopping;

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20, backgroundColor: "#F2F2F2" },
  topBar: { flexDirection: "row", alignItems: "center", marginBottom: 15 },
  addButton: { backgroundColor: Theme.foreground, padding: 10, borderRadius: 5, flexDirection: "row", alignItems: "center" },
  addButtonText: { color: "#fff", marginLeft: 5 },
  filterButton: { marginLeft: 10, padding: 7, borderRadius: 5, backgroundColor: "#e6e6e6" },
  row: { flexDirection: "row", justifyContent: "space-between", alignItems: "center", paddingVertical: 10, borderBottomWidth: 1, borderBottomColor: "#ccc" },
  rowText: { flex: 2 },
  actions: { flexDirection: "row", gap: 10 },
});
